export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./loading.vue?vue&type=template&id=24a16d5c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/loading.vue?vue&type=template&id=24a16d5c&scoped=true&
// module id = null
// module chunks = 